import type { ControlInspector } from "./types"

export const dateTimePicker: ControlInspector<"dateTimePicker"> = {
  Inspector: () => null,
}
